import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListMaterielPage = withAsyncLoading(async () =>
    import('./ListMaterielPage').then((res) => res.ListMaterielPage)
);

export { LoadableListMaterielPage };
